import { createAsyncThunk } from "@reduxjs/toolkit";
import { HOSTNAME } from "../configs/Domain";

export const listCharts = createAsyncThunk(
  'charts/listCharts',
  async (page = 0, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/charts/list?page=${page}`);
      if (!response.ok) {
        throw new Error('Failed to fetch charts');
      }
      const data = await response.json();
      return { data, page };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchChart = createAsyncThunk(
  'charts/fetchChart',
  async (chartTitle, { rejectWithValue, getState }) => {
    try {
      // Check if we already have the plot_data for this chart
      const charts = getState().charts.charts;
      const existingChart = charts.find(chart => chart.title === chartTitle);


      if (existingChart?.plot_data) {
        // If we already have the plot_data, return null to skip the API call
        return null;
      }

      const response = await fetch(`${HOSTNAME}/charts/find?title=${encodeURIComponent(chartTitle)}`);

      if (!response.ok) {
        throw new Error('Failed to fetch chart');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);